
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import { EnumCompanyType } from "@/models.machine/EnumCompanyType";
import MiezzForm from "@/models/MiezzForm";
import DtoFormCompanyFollowUpRecord from "@/models.machine/DtoFormCompanyFollowUpRecord";
import CompanyFollowUpRecordForm from "../../CompanyFollowUpRecord/CompanyFollowUpRecordForm.vue";
@Options({
  components: {
    CompanyFollowUpRecordForm,
  },
})
export default class CustomerCompanyFollowUpRecordAdd extends Vue {
  type = EnumCompanyType.Customer;
  form = new MiezzForm<DtoFormCompanyFollowUpRecord, string>(
    "CustomerManagement_FollowUpRecord_Add"
  );

  created(): void {
    //
  }
}
